import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiCharacters = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M8 3.8A3.4 3.4 0 1 0 8 10.6A3.4 3.4 0 1 0 8 3.8Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 12.6C4.15 12.6 1.4 14.9 1.4 17.9C1.4 18.55 1.92 19.1 2.6 19.1H13.4C14.08 19.1 14.6 18.55 14.6 17.9C14.6 14.9 11.85 12.6 8 12.6Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M15.5 0.9C16 3.7 16.7 4.4 19.4 4.9C16.7 5.4 16 6.1 15.5 8.9C15 6.1 14.3 5.4 11.6 4.9C14.3 4.4 15 3.7 15.5 0.9Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 9.4C18.2 10.6 18.5 10.9 19.7 11.1C18.5 11.3 18.2 11.6 18 12.8C17.8 11.6 17.5 11.3 16.3 11.1C17.5 10.9 17.8 10.6 18 9.4Z" })
	]
});
const ForwardRef = forwardRef(SvgAiCharacters);
export default ForwardRef;
